module.exports = __webpack_public_path__ + "img/3.183c9ca7.svg";